module.exports = __webpack_public_path__ + "img/Sher.1f7ae5ae.png";